import {Component, Injector} from "@angular/core";
import {LocalizedRouter} from "@app/presentation/services/localized-router";
import {TranslateService} from "@ngx-translate/core";
import {DeliveryPoint} from "@app/core/delivery-point/application/dtos/delivery-point";
import {
  SelectDeliveryPointViewModel
} from "@app/presentation/pages/select-delivery-point/select-delivery-point.view-model";
import {PopupDispatcher} from "@app/presentation/components/errors/popup.dispatcher";
import {SIDE_SHEET_DATA} from "@app/presentation/services/side-sheet/side-sheet.service";
import {SideSheetRef} from "@app/presentation/services/side-sheet/side-sheet-ref";
import {
  SELECT_DELIVERY_POINT_DATA,
  SelectDeliveryPointRef
} from "@app/presentation/services/delivery-point/delivery-point.service";

@Component({
  selector: 'app-select-delivery-point',
  templateUrl: './select-delivery-point.component.html',
  styleUrls: ['./select-delivery-point.component.scss'],
  providers: [SelectDeliveryPointViewModel]
})
export class SelectDeliveryPointComponent {

  selectedDeliveryPoint?: DeliveryPoint;

  deliveryPoints: DeliveryPoint[] = [];

  confirmDeliveryPointSelection?: (selectedDeliveryPoint: DeliveryPoint) => void;

  closeWhenSelectDeliveryPoint: boolean = false;

  constructor(
    private localizedRouter: LocalizedRouter,
    private translateService: TranslateService,
    popupDispatcher: PopupDispatcher,
    injector: Injector,
  ) {
    try {
      const sideSheetData = injector.get(SIDE_SHEET_DATA)
      this.deliveryPoints = sideSheetData?.deliveryPoints;
      this.closeWhenSelectDeliveryPoint = sideSheetData?.closeWhenSelectDeliveryPoint;
    } catch { }

    try {
      const sideSheetRef = injector.get(SideSheetRef)
      this.confirmDeliveryPointSelection = (selectedDeliveryPoint) => sideSheetRef.back(selectedDeliveryPoint);
    } catch { }

    try {
      const selectDeliveryPointData = injector.get(SELECT_DELIVERY_POINT_DATA)
      this.deliveryPoints = selectDeliveryPointData?.deliveryPoints;
    } catch { }

    try {
      const selectDeliveryPointRef = injector.get(SelectDeliveryPointRef)
      this.confirmDeliveryPointSelection = (selectedDeliveryPoint) => selectDeliveryPointRef.close(selectedDeliveryPoint);
    } catch { }

  }

  onSelectedDeliveryPoint(deliveryPoint: DeliveryPoint) {
    this.selectedDeliveryPoint = deliveryPoint;
  }

  saveSelectedDeliveryPoint() {
    if(this.selectedDeliveryPoint == null) {
      return;
    }
  }

  onClickButton() {
    if (this.selectedDeliveryPoint == null) {
      return;
    }
    if (this.confirmDeliveryPointSelection != null) this.confirmDeliveryPointSelection(this.selectedDeliveryPoint);
  }
}
